import { Admission } from '@domain/admission';
import { useGenericQuery } from '@hooks/use-generic-query';
import { paramsSerializer } from '@utils/format-params';
import { request } from '@utils/request/request';
import { RequestError, RequestMethod } from '@utils/request/request.type';

import { QUERY_KEYS } from './constants.type';

export const getAdmissionQueryKey = (offerId: string, channelId?: string) => [
  QUERY_KEYS.getAdmission,
  offerId,
  channelId,
];

const getAdmissionById = async (offerId: string, channelId?: string) => {
  const queryParams = paramsSerializer({
    channelId,
  });
  const url = `${import.meta.env.VITE_OFFERS_HOST}/v1/nightgraph/admissions/${offerId}?${queryParams}`;

  return request({ url, method: RequestMethod.GET });
};

export const useGetAdmission = ({
  offerId,
  channelId,
  options,
}: {
  offerId: string;
  channelId?: string;
  options?: Record<string, boolean | number>;
}) => {
  return useGenericQuery<Admission, RequestError>(
    getAdmissionQueryKey(offerId, channelId),
    () => getAdmissionById(offerId, channelId),
    {
      ...options,
    }
  );
};
